// What a page sets to use DAFM LPIS on the farm map. Kept apart from
// DafmLpisSource.js so pages don't load the ArcGIS modules.

// Shows DAFM LPIS on the farm map, for a farmer outside ISEC
export function showDafmLpis(lpis) {
  lpis.source = "dafm";
  lpis.herdNo = "";
  lpis.show = true;
}

// Linking is offered when this server has the data and the farmer is outside
// ISEC, which has its own LPIS
export function canLinkDafmLpis(config, organisationName) {
  return !!config.dafm_lpis?.available && organisationName !== "ISEC";
}
